function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3662 2.97741C13.1038 3.98994 12.0694 4.59835 11.0567 4.3358C10.0441 4.07325 9.43573 3.03926 9.69786 2.02588C9.96082 1.01356 10.9946 0.404947 12.0076 0.667495C13.0203 0.930042 13.6289 1.96467 13.3662 2.97741Z",
  fill: "#33D5BA"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.33132 18.7782C8.19458 19.3047 7.65707 19.6207 7.1303 19.4846C6.60352 19.3479 6.28732 18.8106 6.42386 18.2834C6.56039 17.7564 7.0979 17.4408 7.62468 17.5771C8.15145 17.7132 8.46765 18.2512 8.33132 18.7782Z",
  fill: "#33D5BA"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.8014 7.04465C2.57158 7.2445 3.03377 8.03088 2.83434 8.80044C2.6349 9.57041 1.84894 10.0324 1.07897 9.83295C0.309207 9.63352 -0.153196 8.84756 0.0464495 8.07759C0.245885 7.30825 1.03184 6.84584 1.8014 7.04465Z",
  fill: "#33D5BA"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6025 12.0798C17.8863 12.1533 18.0567 12.4425 17.9829 12.7267C17.9095 13.0103 17.62 13.1803 17.3364 13.1067C17.0528 13.0333 16.8826 12.7436 16.956 12.4598C17.0299 12.1762 17.3191 12.0064 17.6025 12.0798Z",
  fill: "#33D5BA"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.92619 2.0721C9.18347 2.99943 8.63902 3.96021 7.71169 4.21687C6.78394 4.47332 5.82358 3.9295 5.56671 3.00132C5.31005 2.07357 5.85408 1.11363 6.78184 0.856975C7.70917 0.600107 8.66995 1.14393 8.92619 2.0721Z",
  fill: "#33D5BA"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4668 18.2729C12.5894 18.7166 12.3294 19.1759 11.8857 19.2989C11.4418 19.4216 10.9826 19.1618 10.8597 18.7177C10.7371 18.274 10.9971 17.8147 11.4408 17.6921C11.8846 17.5692 12.3439 17.829 12.4668 18.2729Z",
  fill: "#33D5BA"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.13198 11.4832C1.8176 11.293 2.5274 11.6956 2.71716 12.3815C2.90692 13.0673 2.50468 13.7769 1.81907 13.9664C1.13304 14.1566 0.423442 13.7544 0.233684 13.0688C0.0441367 12.3823 0.445952 11.6727 1.13198 11.4832Z",
  fill: "#33D5BA"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.66894 3.57591C5.29544 4.19189 5.30364 5.20022 4.68724 5.8265C4.07106 6.45321 3.06336 6.4612 2.43644 5.8448C1.80995 5.22883 1.80174 4.2205 2.41835 3.59422C3.03475 2.9673 4.04223 2.95888 4.66894 3.57591Z",
  fill: "#33D5BA"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8356 15.8362C16.104 16.1002 16.1076 16.5323 15.8434 16.8003C15.5791 17.069 15.1472 17.0728 14.8788 16.8087C14.6101 16.5443 14.6068 16.1122 14.871 15.844C15.1352 15.5755 15.5669 15.5722 15.8356 15.8362Z",
  fill: "#33D5BA"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.83837 15.6211C3.27869 15.1736 3.99859 15.1675 4.44584 15.608C4.89331 16.0485 4.89941 16.7678 4.4591 17.2159C4.01899 17.6634 3.29909 17.6695 2.85163 17.2285C2.40395 16.7884 2.39806 16.0685 2.83837 15.6211Z",
  fill: "#33D5BA"
});
function SvgLoadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadicon);
export default __webpack_public_path__ + "static/media/loadicon.39d234f1e8cd2bca8eb7ef35fb8802bd.svg";
export { ForwardRef as ReactComponent };